/* eslint-disable max-len */
import React, { FC } from 'react'
import { Breakpoints, media, themeObject } from 'Pages/landings/newLandings/common/style'
import styled from 'styled-components'

const StyledRightIcon = styled.svg`
	width: 24px;
	height: 24px;
	min-height: 24px;
	min-width: 24px;
	margin-left: 8px;
	display: none;
	${media('display: initial;', Breakpoints.ms)}
`

export const ArrowRightIcon: FC<React.HTMLAttributes<unknown>> = () => (
	<StyledRightIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.00342 11.75C4.00342 12.1651 4.3394 12.5016 4.75385 12.5016L17.9932 12.5016L15.6129 14.9499C15.3238 15.2473 15.3238 15.7295 15.6129 16.0269C15.9021 16.3244 16.3709 16.3244 16.66 16.0269L20.2866 12.2968C20.4332 12.146 20.5055 11.9477 20.5034 11.75C20.5055 11.5523 20.4332 11.354 20.2866 11.2032L16.66 7.47305C16.3709 7.17565 15.9021 7.17565 15.6129 7.47305C15.3238 7.77046 15.3238 8.25265 15.6129 8.55006L17.9932 10.9984L4.75385 10.9984C4.3394 10.9984 4.00342 11.3349 4.00342 11.75Z"
			fill={themeObject.colors.base.white}
		/>
	</StyledRightIcon>
)
